function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { defaultGreen, defaultGreenDarker, defaultOrange, defaultOrangeDarker, defaultRed, defaultRedDarker } from "../../utils/colors";
export var stylesError = {
  cssOutlinedInputRed: {
    '&$cssFocused $notchedOutline': {
      borderColor: defaultRed
    },
    '&:hover:not($disabled):not($focused):not($error) $notchedOutline': {
      borderColor: "".concat(defaultRedDarker, " !important")
    }
  },
  cssLabelRed: {
    '&$cssFocused': {
      color: defaultRed
    }
  }
};
export var stylesSuccess = {
  cssOutlinedInputSuccess: {
    '& $notchedOutline': {
      borderColor: defaultGreen
    },
    '&$cssFocused $notchedOutline': {
      borderColor: defaultGreen
    },
    '&:hover:not($disabled):not($focused):not($error) $notchedOutline': {
      borderColor: "".concat(defaultGreenDarker, " !important")
    }
  },
  cssLabelSuccess: {
    '&$cssFocused': {
      color: defaultGreen
    },
    color: defaultGreen
  }
};
export var stylesWarning = {
  cssOutlinedInputWarning: {
    '& $notchedOutline': {
      borderColor: defaultOrange
    },
    '&$cssFocused $notchedOutline': {
      borderColor: defaultOrange
    },
    '&:hover:not($disabled):not($focused):not($error) $notchedOutline': {
      borderColor: "".concat(defaultOrangeDarker, " !important")
    }
  },
  cssLabelWarning: {
    '&$cssFocused': {
      color: defaultOrange
    },
    color: defaultOrange
  }
};
export var styles = function styles(theme) {
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    adornedMarginLeft: {
      marginLeft: theme.spacing(0.5)
    },
    adornedMarginRight: {
      marginRight: theme.spacing(0.5)
    },
    adornedMarginEnd: {
      paddingRight: "0px !important"
    },
    inputRoot: {
      paddingRight: theme.spacing(0.333)
    },
    cssOutlinedInput: {
      '&$focused $notchedOutline $cssFocused': {
        borderColor: function borderColor(_ref) {
          var variant = _ref.variant;
          return variant === 'yellow' ? theme.palette.secondary.main : theme.palette.primary.main;
        }
      }
    },
    cssLabel: {
      '&$focused $cssFocused': {
        color: function color(_ref2) {
          var variant = _ref2.variant;
          return variant === 'yellow' ? theme.palette.secondary.main : theme.palette.primary.main;
        }
      }
    }
  }, stylesError), stylesSuccess), stylesWarning), {}, {
    notchedOutline: function notchedOutline() {
      return {};
    },
    focused: function focused() {
      return {};
    },
    cssFocused: function cssFocused() {
      return {};
    },
    error: function error() {
      return {};
    },
    disabled: function disabled() {
      return {};
    }
  });
};